import { z } from "zod";
import type {
    FeeSourceTransactionsFilterPaymentProvider} from "./fee-source-transactions-filters-payment-provider";
import {
    feeSourceTransactionsFilterPaymentProviderFactory,
    feeSourceTransactionsFilterPaymentProviderZodSchema,
} from "./fee-source-transactions-filters-payment-provider";
import type {
    FeeSourceTransactionsFilterTransactionType} from "./fee-source-transactions-filters-type";
import {
    feeSourceTransactionsFilterTransactionTypeFactory,
    feeSourceTransactionsFilterTransactionTypeZodSchema,
} from "./fee-source-transactions-filters-type";

type FeeSourceTransactionsFilter =
    | FeeSourceTransactionsFilterPaymentProvider
    | FeeSourceTransactionsFilterTransactionType;

const feeSourceTransactionsFilterZodSchema = z.union([
    feeSourceTransactionsFilterPaymentProviderZodSchema,
    feeSourceTransactionsFilterTransactionTypeZodSchema,
]);

type FeeSourceTransactionsFilterType = FeeSourceTransactionsFilter["type"];

const feeSourceTransactionFilterFactory = (
    type: FeeSourceTransactionsFilterType
) => {
    switch (type) {
        case "PAYMENT_PROVIDER":
            return feeSourceTransactionsFilterPaymentProviderFactory({
                paymentProvider: "STRIPE",
            });
        case "TRANSACTION_TYPE":
            return feeSourceTransactionsFilterTransactionTypeFactory({
                transactionType: "CAPTURE",
            });
    }
};

export type { FeeSourceTransactionsFilter };
export {
    feeSourceTransactionsFilterZodSchema,
    feeSourceTransactionFilterFactory,
};
